module.exports = {
  title: '用户审核',
  route: {
    path: 'user-manage',
    children: {
      path: 'user-audit-list',
    },
  },
};
